import { useMemo } from 'react';
import { useMe } from '@/lib/queries/identity';
import type { IntakePrefillValues } from './intake-answer-model';

// Applicant profile values used to prefill recommended region/sector intake
// questions: region <- the profile's place text (fallback: the legacy location
// string); sector <- industry. Empty until the profile query resolves — it is
// cached app-wide so this is usually immediate, and a late resolve re-seeds
// only still-empty prefill fields (mergeAnswers never overwrites a touched
// answer). Shared by both applicant surfaces (member join A/B, Circle→Network C).
export function useIntakePrefill(): IntakePrefillValues {
  const { data } = useMe();
  return useMemo(() => {
    if (data === undefined) return {};
    const out: IntakePrefillValues = {};
    const region = data.place?.text ?? data.location;
    if (region != null && region.trim().length > 0) out.region = region;
    if (data.industry != null && data.industry.trim().length > 0) {
      out.sector = data.industry;
    }
    return out;
  }, [data]);
}
